import { LoadingSpinner } from '@medtronic/pecc-react-component-library-js';
import { Box } from '@mui/material';

const ButtonSpinner = () => (
  <Box pl="1rem">
    <LoadingSpinner spinnerSize="xxs" />
  </Box>
);

export default ButtonSpinner;
